import { Button, Image, Input, Switch, Table, Tooltip } from "antd";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import notfound from "../../assets/images/not_found.png";
import Plus from "../../assets/images/plus.svg";
import SectionWrapper from "../../components/SectionWrapper";
import apiPath from "../../constants/apiPath";
import { Severty, ShowToast } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import useRequest from "../../hooks/useRequest";
import AddForm from "./AddForm";
import { AppStateContext } from "../../context/AppContext";
import lang from "../../helper/langHelper";
import deleteWhiteIcon from "../../assets/images/icon/deleteWhiteIcon.png";
import DeleteModal from "../../components/DeleteModal";
import EditIcon from "../../assets/images/edit.svg";
import ShowTotal from "../../components/ShowTotal";

function Index() {
  const heading = "Vendor Management";
  const { setPageHeading } = useContext(AppStateContext);
  const { request } = useRequest();

  const api = {
    status: apiPath.statusVendor,
    addEdit: apiPath.vendor,
    list: apiPath.vendor,
  };

  const [searchText, setSearchText] = useState("");
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [deleteModal, showDeleteModal] = useState(false);
  const [selected, setSelected] = useState();
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const debouncedSearchText = useDebounce(searchText, 300);

  const handleChangeStatus = (id) => {
    request({
      url: api.status + "/" + id,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        setRefresh((prev) => !prev);
        ShowToast(data.message, Severty.SUCCESS);
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const onDelete = (id) => {
    request({
      url: api.addEdit + "/" + id,
      method: "DELETE",
      onSuccess: () => {
        setLoading(false);
        setRefresh((prev) => !prev);
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const columns = [
    {
      title: lang("Image"),
      dataIndex: "image",
      key: "image",
      render: (_, { image }) => <Image width={58} src={image ? image : notfound} className="table-img" />,
    },
    {
      title: lang("Vendor Name"),
      dataIndex: "name",
      key: "name",
      render: (_, { name }) => (name ? <span className="cap">{name}</span> : "-"),
    },
    {
      title: lang("Affiliate Link"),
      dataIndex: "affiliateLink",
      key: "affiliateLink",
      render: (_, { affiliateLink }) =>
        affiliateLink ? (
          <a href={affiliateLink} target="_blank" rel="noopener noreferrer" className="cap">
            {affiliateLink}
          </a>
        ) : (
          "-"
        ),
    },
    {
      title: lang("Sequence"),
      dataIndex: "sequence",
      key: "sequence",
      render: (_, { sequence }) => <span className="cap">{sequence ?? 0}</span>,
    },
    {
      title: lang("Created Date"),
      key: "createdAt",
      dataIndex: "createdAt",
      render: (_, { createdAt }) => (createdAt ? moment(createdAt).format("DD-MMM-YYYY") : "-"),
    },
    {
      title: lang("Action"),
      fixed: "right",
      key: "action",
      render: (_, record) => (
        <div className="d-flex justify-contenbt-start">
          <Tooltip title={lang("Edit")} color={"purple"} key={"update-vendor"}>
            <Button
              title="Edit"
              className="edit-cls btnStyle primary_btn"
              onClick={() => {
                setSelected(record);
                setVisible(true);
              }}
            >
              <img src={EditIcon} alt="" />
            </Button>
          </Tooltip>

          <Tooltip title={lang("Delete")} color={"purple"} key={"delete-vendor"}>
            <Button
              title={lang("Delete")}
              className="btnStyle deleteDangerbtn"
              onClick={() => {
                setSelected(record);
                showDeleteModal(true);
              }}
            >
              <img src={deleteWhiteIcon} alt="" />
            </Button>
          </Tooltip>
        </div>
      ),
    },
    {
      title: lang("Status"),
      key: "isActive",
      dataIndex: "isActive",
      filters: [
        { text: "Active", value: "true" },
        { text: "InActive", value: "false" },
      ],
      render: (_, { _id, isActive }) => <Switch onChange={() => handleChangeStatus(_id)} checked={isActive} />,
    },
  ];

  useEffect(() => {
    setLoading(true);
    fetchData(pagination);
  }, [refresh, debouncedSearchText]);

  useEffect(() => {
    setPageHeading(heading);
  }, [setPageHeading]);

  const fetchData = (pagination, filters) => {
    const filterActive = filters ? filters.isActive : null;
    request({
      url: api.list + `?status=${filterActive ? filterActive.join(",") : ""}&page=${pagination ? pagination.current : 1}&pageSize=${pagination ? pagination.pageSize : 10}&search=${debouncedSearchText}`,
      method: "GET",
      onSuccess: ({ data }) => {
        setLoading(false);
        setList(() =>
          (data.docs || []).map((item) => ({
            ...item,
            key: item._id,
          })),
        );
        setPagination((prev) => ({
          ...prev,
          current: pagination.current,
          total: data.totalDocs,
        }));
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChange = (pagination, filters) => {
    fetchData(pagination, filters);
  };

  const onSearch = (e) => {
    setSearchText(e.target.value);
  };

  return (
    <>
      <SectionWrapper
        cardHeading={lang(`All Vendors`)}
        extra={
          <div className="w-100 text-head_right_cont">
            <div className="pageHeadingSearch">
              <Input.Search className="searchInput" placeholder={lang("Search by vendor name")} onChange={onSearch} allowClear />
            </div>
            <Button
              className="primary_btn btnStyle"
              onClick={() => {
                setSelected();
                setVisible(true);
                setSearchText("");
              }}
            >
              <span className="add-Ic">
                <img src={Plus} alt="" />
              </span>
              {lang("Add New Vendor")}
            </Button>
          </div>
        }
      >
        <h4 className="text-right mb-1cont-space cont-space">{pagination.total ? ShowTotal(pagination.total) : ShowTotal(0)}</h4>
        <div className="table-responsive customPagination checkBoxSrNo">
          <Table
            loading={loading}
            columns={columns}
            dataSource={list}
            pagination={{
              defaultPageSize: 10,
              responsive: true,
              total: pagination.total,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ["10", "20", "30", "50"],
            }}
            onChange={handleChange}
            className="ant-border-space"
          />
        </div>
      </SectionWrapper>

      {visible && (
        <AddForm
          api={api}
          show={visible}
          hide={() => {
            setSelected();
            setVisible(false);
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      {deleteModal && (
        <DeleteModal
          reasons={[]}
          title={lang("Delete Vendor")}
          subtitle={lang(`Are you sure you want to Delete this vendor?`)}
          show={deleteModal}
          hide={() => {
            showDeleteModal(false);
            setSelected();
          }}
          onOk={() => onDelete(selected?._id)}
        />
      )}
    </>
  );
}

export default Index;
